import solutionImageOne from '@/assets/images/our_solutions_01.png'
import workImageOne from '@/assets/images/our_work_01.png'
import TecmaHeader from '@/layouts/TecmaHeader'

import './ProductsPage.css'

import { products } from '../data/products'
import FilterSidebar from '../components/FilterSidebar'
import PriceNotice from '../components/PriceNotice'
import ProductCard from '../components/ProductCard'
import ProductFeature from '../components/ProductFeature'
import ProductHero from '../components/ProductHero'
import ProductToolbar from '../components/ProductToolbar'
import ProductsCta from '../components/ProductsCta'

export default function ProductsPage() {
  return (
    <div className="products-page">
      <TecmaHeader activeItem="Products" theme="light" />
      <ProductHero imageSrc={workImageOne} />
      <main className="relative bg-[#e9ebf6] px-5 py-9 min-[900px]:px-0 min-[900px]:pb-[204px] min-[900px]:pt-9">
        <div className="relative mx-auto max-w-[1080px]">
          <section className="grid gap-12 min-[900px]:grid-cols-[290px_1fr] min-[900px]:items-start min-[900px]:gap-8">
            <PriceNotice />
            <ProductFeature imageSrc={solutionImageOne} />
          </section>
          <section id="products" className="mt-8">
            <div className="grid gap-6 min-[900px]:grid-cols-[220px_1fr] min-[900px]:gap-8">
              <FilterSidebar />
              <div>
                <ProductToolbar />
                <div className="mt-6 grid gap-5 min-[600px]:grid-cols-2 min-[900px]:grid-cols-3">
                  {products.map((product) => <ProductCard key={product.item} {...product} />)}
                </div>
              </div>
            </div>
          </section>
          <ProductsCta />
        </div>
      </main>
    </div>
  )
}
